export const topologyOptionsLight = {
   nodes: {
      borderWidth: 1,
      borderWidthSelected: 3,
      color: {
         background: '#2EE06D',
         border: '#000000',
         highlight: {
            background: '#2EE06D',
            border: '#000000'
         },
         hover: {
            background: '#2EE06D',
            border: '#000000'
         }
      },
      shadow: {
         enabled: true
      },
      font: {
         size: 16,
         color: '#000000',
         strokeWidth: 4
      },
      shape: 'hexagon',
      size: 20,
      physics: false
   },
   edges: {
      arrows: {
         to: {
            enabled: true
         }
      },
      color: {
         color: '#000000',
         highlight: '#000000',
         hover: '#000000'
      },
      font: {
         color: '#000000',
         size: 12,
         strokeWidth: 10
      },
      dashes: true,
      length: 200,
      width: 2,
      selectionWidth: 1
   }
};
export const topologyOptionsDark = {
   nodes: {
      borderWidth: 1,
      borderWidthSelected: 3,
      color: {
         background: '#2EE06D',
         border: '#181919',
         highlight: {
            background: '#2EE06D',
            border: '#181919'
         },
         hover: {
            background: '#2EE06D',
            border: '#181919'
         }
      },
      shadow: {
         enabled: false
      },
      font: {
         size: 16,
         color: '#FFFFFF',
         strokeWidth: 4,
         strokeColor: '#181919'
      },
      shape: 'hexagon',
      size: 20,
      physics: false
   },
   edges: {
      arrows: {
         to: {
            enabled: true
         }
      },
      color: {
         color: '#FFCD2C',
         highlight: '#FFCD2C',
         hover: '#FFCD2C'
      },
      font: {
         color: '#FFFFFF',
         size: 12,
         strokeWidth: 10,
         strokeColor: '#181919'

      },
      dashes: true,
      length: 200,
      width: 2,
      selectionWidth: 1
   }
};